export class DivisionUserDetails{
    divisionId:number;
    divisionName:string;
    userId:number;
    username:string;
}